import CreateButtonView from "./CreateButtonView";

/**
 * Container component for the create invitation button.
 * Provides wrapper for the button view component.
 */
const CreateButtonContainer = () => {
  return <CreateButtonView />;
};

export default CreateButtonContainer;
